import { createI18n } from 'vue-i18n';
import { initLanguage } from '@/composables/useLang';

// Import language files
import en from '@/locales/en.json';
import de from '@/locales/de.json';

// Messages object containing all translations
const messages = {
  en,
  de
};

// Create i18n instance with options
export default createI18n({
  legacy: false, // Use Composition API mode
  globalInjection: true, // Inject $t, $d into templates
  locale: initLanguage(), // Use browser language or saved preference
  fallbackLocale: 'en', // Fallback language
  messages,
  silentTranslationWarn: process.env.NODE_ENV === 'production', // Only show warnings in development
  silentFallbackWarn: process.env.NODE_ENV === 'production',
  // Optimization: avoid parsing full date objects
  datetimeFormats: {
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric'
      }
    },
    de: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric'
      }
    }
  },
  // Number formatting options
  numberFormats: {
    en: {
      currency: {
        style: 'currency',
        currency: 'EUR'
      }
    },
    de: {
      currency: {
        style: 'currency',
        currency: 'EUR'
      }
    }
  }
});